var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1C347A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66156 3.8745C4.94482 4.34232 4.33366 4.95463 3.86719 5.67225V3.8745H5.66156ZM14.1013 5.62388C13.6388 4.9269 13.0389 4.33163 12.3384 3.8745H14.1013V5.62388ZM12.3643 14.1086C13.0538 13.6536 13.6445 13.0644 14.1013 12.3761V14.1086H12.3643ZM3.86719 12.3278C4.32796 13.0367 4.93 13.6429 5.63569 14.1086H3.86719V12.3278ZM14.625 9C14.625 12.1016 12.1016 14.625 9 14.625C5.89838 14.625 3.375 12.1016 3.375 9C3.375 5.89838 5.89838 3.375 9 3.375C12.1016 3.375 14.625 5.89838 14.625 9ZM9 13.1017C11.2613 13.1017 13.1017 11.2618 13.1017 9C13.1017 6.73875 11.2618 4.89825 9 4.89825C6.73875 4.89825 4.89825 6.73819 4.89825 9C4.89825 11.2613 6.73819 13.1017 9 13.1017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmni);
export default __webpack_public_path__ + "static/media/omni.7622df9bead406a039983e7472eb341e.svg";
export { ForwardRef as ReactComponent };